import { createSessionPayloadStore } from "./sessionPayloadStore";

interface PendingGoldReleaseAutoPurchase {
  releaseId: number;
}

function isPendingGoldReleaseAutoPurchase(
  value: unknown,
): value is PendingGoldReleaseAutoPurchase {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as PendingGoldReleaseAutoPurchase).releaseId === "number"
  );
}

const pendingGoldReleaseAutoPurchaseStore =
  createSessionPayloadStore<PendingGoldReleaseAutoPurchase>(
    "pendingGoldReleaseAutoPurchase",
    isPendingGoldReleaseAutoPurchase,
  );

export function markPendingGoldReleaseAutoPurchase(releaseId: number): void {
  pendingGoldReleaseAutoPurchaseStore.persist({ releaseId });
}

export function hasPendingGoldReleaseAutoPurchase(
  releaseId: number | undefined,
): boolean {
  return (
    releaseId !== undefined &&
    pendingGoldReleaseAutoPurchaseStore.read()?.releaseId === releaseId
  );
}

export function clearPendingGoldReleaseAutoPurchase(): void {
  pendingGoldReleaseAutoPurchaseStore.clear();
}
